/*=============================================== TabsPage ===============================================*/

import { Tabs, Text } from "tsx-library-julseb"
import type { TabsItemProps } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const TabsPage = () => {
    const tabsItems: TabsItemProps[] = [
        {
            title: "Tab 1",
            content: "Content tab 1",
        },
        {
            title: "Tab 2",
            content: (
                <>
                    <Text>Hello</Text>
                    <Text>World</Text>
                </>
            ),
        },
        {
            title: "Tab 3",
            content: "Content tab 3",
        },
    ]

    const items: ItemType[] = [
        {
            title: "Basic",
            content: (
                <Tabs
                    items={tabsItems}
                    variant="basic"
                    justify="start"
                    showInUrl
                />
            ),
            code: 'const tabsItems = [\n    {\n        title: "Tab 1",\n        content: "Content tab 1",\n    },\n    {\n        title: "Tab 2",\n        content: (\n            <>\n                <Text>Hello</Text>\n                <Text>World</Text>\n            </>\n        ),\n    },\n    {\n        title: "Tab 3",\n        content: "Content tab 3",\n    },\n]\n\n<Tabs items={tabsItems} variant="basic" justify="start" showInUrl />',
            codeTs: 'const tabsItems: TabsItemProps[] = [\n    {\n        title: "Tab 1",\n        content: "Content tab 1",\n    },\n    {\n        title: "Tab 2",\n        content: (\n            <>\n                <Text>Hello</Text>\n                <Text>World</Text>\n            </>\n        ),\n    },\n    {\n        title: "Tab 3",\n        content: "Content tab 3",\n    },\n]\n\n<Tabs items={tabsItems} variant="basic" justify="start" showInUrl />',
        },
        {
            title: "Rounded",
            content: (
                <Tabs items={tabsItems} variant="rounded" justify="stretch" />
            ),
            code: 'const tabsItems = [\n    {\n        title: "Tab 1",\n        content: "Content tab 1",\n    },\n    {\n        title: "Tab 2",\n        content: (\n            <>\n                <Text>Hello</Text>\n                <Text>World</Text>\n            </>\n        ),\n    },\n    {\n        title: "Tab 3",\n        content: "Content tab 3",\n    },\n]\n\n<Tabs items={tabsItems} variant="rounded" justify="stretch" />',
            codeTs: 'const tabsItems: TabsItemProps[] = [\n    {\n        title: "Tab 1",\n        content: "Content tab 1",\n    },\n    {\n        title: "Tab 2",\n        content: (\n            <>\n                <Text>Hello</Text>\n                <Text>World</Text>\n            </>\n        ),\n    },\n    {\n        title: "Tab 3",\n        content: "Content tab 3",\n    },\n]\n\n<Tabs items={tabsItems} variant="rounded" justify="stretch" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "variant",
            type: "string",
            possible: ["basic", "rounded"],
            default: "basic",
        },
        {
            subtitle: "justify",
            type: "string",
            possible: ["start", "stretch"],
            default: "start",
        },
        {
            subtitle: "active",
            type: "number",
            default: 0,
        },
        {
            subtitle: "showInUrl",
            intro: (
                <>
                    Shows the <code>active tab's</code> number in the page's
                    url. {commonProps.routerOnly}
                </>
            ),
            type: "boolean",
        },
        {
            subtitle: "queries",
            intro: (
                <>
                    In case you have other <code>queries</code> in your page's
                    url.
                </>
            ),
            type: "array of array of strings",
        },
        "separator",
        {
            subtitle: "items",
            type: "array of objects",
            required: true,
        },
        {
            title: (
                <>
                    <code>item</code> object
                </>
            ),
            subtitle: "title",
            type: "string",
            required: true,
        },
        {
            subtitle: "content",
            type: "string or JSX Element",
            required: true,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default TabsPage
